import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { ViewCart } from "./ViewCart";
import {
  MdOutlineHome,
  MdWorkOutline,
  MdOtherHouses,
  MdOutlineAddCircleOutline,
} from "react-icons/md";
import { HiOutlineArrowLeft, HiOutlineLocationMarker } from "react-icons/hi";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { MdErrorOutline } from "react-icons/md";
import axiosConfig from "../../Service/axiosConfig";
import { useSelector, useDispatch } from "react-redux";
import {
  selectCartTotal,
  selectCartProducts,
  fetchProducts,
} from "../../redux/Slices/cartSlice";
import { PopupModal } from "../PopupModal";

const ViewCartModal = (props) => {
  let dispatch = useDispatch();
  const total = useSelector(selectCartTotal);
  const products = useSelector(selectCartProducts);
  const { cart } = useSelector((state) => state);
  // console.log(cart.products)
  const [Error, setError] = useState("");
  const [error, seterror] = useState(false);
  const [popupType, setPopupType] = useState("");
  const [message, setMessage] = useState("");
  const [pincode, setPincode] = useState("");
  const [DefaultPincode, setDefaultPincode] = useState("");
  const [miniPopUp, setMiniPopUp] = useState(false);

  // Tracks whether the chosen delivery address (or current location) is
  // within the store's serviceable radius. Driven by /stores/get_store/
  // which returns store_id=null when the location is outside the 4 km
  // delivery zone configured on the backend.
  const [serviceability, setServiceability] = useState({
    status: "idle", // "idle" | "checking" | "serviceable" | "not_serviceable" | "store_offline" | "error"
    message: "",
  });

  const [productAmount, setProductAmount] = useState({
    mrp: 0,
    discount: 0,
    delviryCharges: 0,
    PackingCharges: 0,
    totalAmount: 0,
    proamount: 0,
    delivery_waived: null,
    packing_waived: null,
  });

  const {
    count,
    setCount,
    show,
    setShow,
    handleClose,
    orderAddress,
    setOrderAddress,
    setOrders,
    Order,
    ProductData,
    setTotalAmount,
    ChangeAddress,
    GetTheAddress,
    PayMentNavigate,
    handleLoginShow,
    Totalamount,
    MovetoCart,
    isMobile,
    HandleAddress,
    storeNull,
    Address,
    GetAddress,
    travelTime,
    errorMessage,
    setErrorMessage,
  } = props;

  const ProductMRP = async (data) => {
    if (!data || !Array.isArray(data)) {
      throw new Error("Invalid data provided");
    }
    const currentStoreId = localStorage.getItem("storeId");
    if (!currentStoreId) {
      // Avoid hitting delivery charge API with a null store; this was causing
      // backend 500s and noisy logs before a location/store is selected.
      return;
    }

    const totalPrice = data.reduce((acc, product) => {
      const price = parseFloat(product.price);
      const quantity = parseInt(product.quantity);
      return acc + price * quantity;
    }, 0);

    const offerPrice = data.reduce((acc, product) => {
      const oprice = parseFloat(
        product.offer_price > 0 ? product.offer_price : product.price
      );
      const quantity = parseInt(product.quantity);
      return acc + oprice * quantity;
    }, 0);

    let delivery_charges = 0;
    let packing_charges = 0;
    let spike_comment = null;
    let totalwt = {
      stores: JSON.parse(currentStoreId),
      products: [],
    };
    let delivery_waived = null;
    let packing_waived = null;
    let spike_percentage = null;
    let free_delivery_charges;

    if (
      JSON.parse(localStorage.getItem("site_data")).ecommerce_type ===
      "Conventional"
    ) {
      totalwt.area = orderAddress?.landmark;
      totalwt.pincode = orderAddress?.pincode;
    }

    data.forEach((item) => {
      totalwt.products.push({
        id: item.id,
        min_qty: item.quantity,
      });
      ProductData.push({
        id: item.id,
        min_qty: item.quantity,
      });
    });

    try {
      axiosConfig.defaults.headers["Content-Type"] = "application/json";
      const charges_response = await axiosConfig.post(
        "accounts/get_delivery_packing_charges/",
        totalwt
      );

      if (!charges_response || !charges_response.data) {
        throw new Error("Invalid response from server");
      }

      const responseData = charges_response.data;

      if (
        JSON.parse(localStorage.getItem("site_data")).ecommerce_type ===
        "Conventional"
      ) {
        if (responseData.message) {
          setError(responseData.message);
        } else {
          delivery_charges = responseData.conventional_delivery_waiver_charges
            ? 0
            : responseData.conventional_delivery_charges;
          packing_charges = responseData.conventional_packing_waiver_charges
            ? 0
            : responseData.conventional_packing_charges;
          delivery_waived = responseData.conventional_delivery_waiver_charges
            ? responseData.conventional_delivery_charges
            : null;
          packing_waived = responseData.conventional_packing_waiver_charges
            ? responseData.conventional_packing_charges
            : null;
          spike_comment = responseData.spike_comment || null;
          spike_percentage = responseData.spike_percentage || null;
          setError("");
          if (orderAddress) {
            localStorage.setItem("address_id", orderAddress.id);
            localStorage.setItem(
              "address",
              `${orderAddress.address}, ${orderAddress.landmark}, ${orderAddress.pincode}`
            );
          }
        }
      } else {
        delivery_charges = responseData.express_waier_delivery_charges
          ? 0
          : responseData.express_delivery_charges;
        packing_charges = responseData.express_waier_packing_charges
          ? 0
          : responseData.express_packing_charges;
        spike_comment = responseData.spike_comment || null;
        delivery_waived = responseData.express_waier_delivery_charges
          ? responseData.express_delivery_charges
          : null;
        packing_waived = responseData.express_waier_packing_charges
          ? responseData.express_packing_charges
          : null;
        spike_percentage = responseData.spike_percentage || null;
        free_delivery_charges = responseData.free_delivery_charges || false;
        setError("");
      }

      // Order Again pinned charges override
      const pinnedDelivery = localStorage.getItem("oa_delivery_charges");
      const pinnedPacking  = localStorage.getItem("oa_packing_charges");
      if (pinnedDelivery !== null) {
        delivery_charges = parseFloat(pinnedDelivery);
        delivery_waived = null;
      }
      if (pinnedPacking !== null) {
        packing_charges = parseFloat(pinnedPacking);
        packing_waived = null;
      }

      setTotalAmount({
        Total_amount: cart.total + delivery_charges + packing_charges,
      });

      setOrders({
        ...Order,
        packing_charges,
        delivery_charges,
        spike_comment,
        spike_percentage,
        stores: localStorage.getItem("storeId"),
        user_id: parseFloat(localStorage.getItem("userId")),
        address:
          orderAddress?.id ||
          localStorage.getItem("address_id") ||
          (Address && Address[0]?.id) ||
          null,
        delivery_type:
          JSON.parse(localStorage.getItem("site_data")).ecommerce_type ===
            "Conventional"
            ? ""
            : "Express",
        products: ProductData,
        free_delivery_charges,
      });

      setProductAmount &&
        setProductAmount({
          mrp: totalPrice,
          discount: totalPrice - offerPrice,
          deliveryCharges: delivery_charges,
          PackingCharges: packing_charges,
          totalAmount: cart.total + delivery_charges + packing_charges,
          proamount: totalPrice,
          delivery_waived,
          packing_waived,
        });

      console.error("Geolocation is not supported by this browser.");
    } catch (error) {
      console.log(
        error.response?.data?.error ||
        "Delivery charges not found for the given parameters"
      );
    }
  };

  useEffect(() => {
    if (errorMessage) {
      const msg =
        typeof errorMessage === "string"
          ? errorMessage.includes("-")
            ? errorMessage.split("-").slice(1).join("-")
            : errorMessage
          : errorMessage?.message || "Failed to proceed to checkout";

      setPopupType(""); // reset popup
      setError(msg);
      setMessage(msg);

      setTimeout(() => {
        setPopupType("error"); // reopen popup
      }, 10);
    }
  }, [errorMessage]);

  const localityFilter = async () => {
    if (pincode.length === 6) {
      try {
        const res = await axiosConfig.get(
          `/masters/areas/?city=&is_suspended=false&pincode=${pincode}`
        );
        if (res.data.results.length > 0) {
          localStorage.setItem("pincode", pincode);
          setDefaultPincode(pincode);
          setPincode("");
          setError(false);
        } else {
          setError(true);
          setDefaultPincode("");
          setPincode("");
        }
      } catch (error) {
        console.error(error);
        setError(true);
        setDefaultPincode("");
        setPincode("");
      }
    } else {
      console.log("disbled");
      setDefaultPincode("");
      setPincode("");
    }
  };

  useEffect(() => {
    ProductMRP(cart.products);
    const pincode = localStorage.getItem("pincode");
    if (pincode) {
      setDefaultPincode(pincode);
    }
  }, [
    cart.products,
    localStorage.getItem("latitude"),
    orderAddress,
    localStorage.getItem("longitude"),
  ]);

  useEffect(() => {
    if (Address && Address.length > 0) {
      // FIRST PRIORITY → if localStorage has address_id use that
      const savedId = localStorage.getItem("address_id");

      if (savedId) {
        const selected = Address.find(
          (item) => item.id === parseInt(savedId)
        );

        if (selected) {
          setOrderAddress(selected);
          return;
        }
      }

      // SECOND PRIORITY → if no selected address yet
      if (!orderAddress && Address[0]) {
        setOrderAddress(Address[0]);
        if (Address[0].id) {
          localStorage.setItem("address_id", Address[0].id);
        }
      }
    }
  }, [Address]);

  // After the backend (or fallback scan) finds a store that can serve the
  // current address, persist it as the active store so /accounts/orders/
  // and the bill-charges call use the correct store rather than whatever
  // store was picked on the homepage.
  const adoptStore = (store) => {
    const storeId = store.id || store.store_id;
    if (!storeId) return;
    const previousStoreId = localStorage.getItem("storeId");
    if (String(previousStoreId) === String(storeId)) return;
    localStorage.setItem("storeId", storeId);
    if (store.opens_at) localStorage.setItem("opens_at", store.opens_at);
    if (store.closes_at) localStorage.setItem("closes_at", store.closes_at);
    if (store.slot_duration) localStorage.setItem("slot_duration", store.slot_duration);
    // Do NOT overwrite localStorage("address") here — that key holds the user's
    // selected delivery location displayed in the Navbar and must only be updated
    // when the user explicitly changes their location, not as a side-effect of
    // opening the cart.
    if (store.latitude) localStorage.setItem("store_latitude", store.latitude);
    if (store.longitude) localStorage.setItem("store_longitude", store.longitude);
    // Push the new store id into the in-progress order so the very next
    // bill calculation / payment navigation hits the right store.
    if (setOrders) {
      setOrders((prev) => ({ ...(prev || {}), stores: storeId }));
    }
  };

  // Validates that the chosen delivery address (or current location, when
  // no address has been picked yet) is within the store's serviceable
  // polygon boundary.
  const checkServiceability = async () => {
    try {
      const siteData = JSON.parse(localStorage.getItem("site_data") || "{}");
      // Pincode-based mode handles its own validation flow elsewhere.
      if (siteData?.ecommerce_type === "Conventional") {
        setServiceability({ status: "idle", message: "" });
        return;
      }

      const lat = orderAddress?.latitude || localStorage.getItem("latitude");
      const lng = orderAddress?.longitude || localStorage.getItem("longitude");

      if (!lat || !lng) {
        setServiceability({
          status: "idle",
          message: "",
        });
        return;
      }

      setServiceability({ status: "checking", message: "Checking if we deliver to this location..." });
      const response = await axiosConfig.get(
        `/stores/get_store/?latitude=${lat}&longitude=${lng}`
      );
      const msg = response?.data?.Message || {};

      if (!msg.store_id) {
        setServiceability({
          status: "not_serviceable",
          message:
            "Sorry, this location is outside our delivery area. No nearby store can deliver to this address.",
        });
        return;
      }

      adoptStore({
        id: msg.store_id,
        opens_at: msg.opens_at,
        closes_at: msg.closes_at,
        slot_duration: msg.slot_duration,
        address: msg.address,
      });

      if (msg.is_online === "offline") {
        setServiceability({
          status: "store_offline",
          message: `The nearest store is currently closed${msg.opens_at ? `. Opens at ${msg.opens_at}` : ""}.`,
        });
        return;
      }
      setServiceability({
        status: "serviceable",
        message: "Great! This address is within our delivery range.",
      });
    } catch (err) {
      console.log(err);
      setServiceability({
        status: "error",
        message: "Could not verify serviceability for this address. Please try again.",
      });
    }
  };

  // Re-check serviceability whenever the chosen address (or modal visibility)
  // changes.
  useEffect(() => {
    if (!show) return;
    if (count !== 1) return;
    checkServiceability();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, count, orderAddress?.id, orderAddress?.latitude, orderAddress?.longitude]);

  const isProceedBlocked =
    serviceability.status === "not_serviceable" ||
    serviceability.status === "store_offline" ||
    serviceability.status === "checking";

  return (
    <div>
      {count === 1 && (
        <Modal
          show={show}
          onHide={handleClose}
          className={`popup-cart ${miniPopUp ? "zindex-0" : ""}`}
        >
          <Modal.Header closeButton>
            <Modal.Title>My Cart</Modal.Title>
          </Modal.Header>
          <Modal.Body
            className={orderAddress ? "cart-modal-rn" : "cart-modal-address"}
          >
            <div>
              <ViewCart
                handleClose={handleClose}
                ProductData={ProductData}
                Order={Order}
                orderAddress={orderAddress}
                setOrders={setOrders}
                setProductAmount={setProductAmount}
                productAmount={productAmount}
                setTotalAmount={setTotalAmount}
                travelTime={travelTime}
                setMiniPopUp={setMiniPopUp}
              />
            </div>
          </Modal.Body>
          {products.length > 0 ? (
            <Modal.Footer>
              <div className="delivery-location">
                {orderAddress && (
                  <div className="row">
                    <div className="col-2 nav-locat-icon">
                      {(orderAddress.adress_type === "Home" && (
                        <MdOutlineHome />
                      )) ||
                        (orderAddress.adress_type === "Work" && (
                          <MdWorkOutline />
                        )) ||
                        (orderAddress.adress_type === "Others" && (
                          <MdOtherHouses />
                        ))}
                    </div>
                    <div className="col-10">
                      <p className="add-type">
                        Delivering to {orderAddress.adress_type}
                      </p>
                      <div className="row">
                        <div className="col-10">
                          <p className="del-address">
                            {orderAddress.name},{orderAddress.flat_no},
                            {orderAddress.address},{orderAddress.landmark},
                            {orderAddress.pincode}
                          </p>
                        </div>
                        <div
                          className="col-2 change-nav"
                          onClick={ChangeAddress}
                        >
                          <p>Change</p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {/* Serviceability validation banner */}
                {serviceability.status !== "idle" && (
                  <div
                    className={`serviceability-banner serviceability-${serviceability.status}`}
                    role={
                      serviceability.status === "not_serviceable" ||
                      serviceability.status === "store_offline" ||
                      serviceability.status === "error"
                        ? "alert"
                        : "status"
                    }
                  >
                    {serviceability.status === "serviceable" ? (
                      <IoMdCheckmarkCircleOutline size={18} className="me-1" />
                    ) : serviceability.status === "checking" ? (
                      <HiOutlineLocationMarker size={18} className="me-1" />
                    ) : (
                      <MdErrorOutline size={18} className="me-1" />
                    )}
                    <span>{serviceability.message}</span>
                  </div>
                )}
              </div>
              <button
                className="btn btn-success btn-proceed"
                disabled={isProceedBlocked}
                onClick={() => {
                  if (isProceedBlocked) return;

                  if (!localStorage.getItem("userId")) {
                    handleLoginShow();
                    return;
                  }

                  if (orderAddress === undefined) {
                    GetTheAddress();
                    return;
                  }

                  PayMentNavigate();
                }}
              >
                <p className="p-qty">
                  {cart.products.length > 0 ? (
                    <>
                      <div>
                        <span className="p-price">
                          ₹{parseFloat(Totalamount.Total_amount).toFixed(2)}
                        </span>
                        <div className="total-text">TOTAL</div>
                      </div>
                      <p className="p-pay">Proceed</p>
                    </>
                  ) : (
                    <p>My Cart</p>
                  )}
                </p>
              </button>
            </Modal.Footer>
          ) : (
            ""
          )}
        </Modal>
      )}
      {count === 2 && (
        <Modal show={show} onHide={handleClose} className="popup-cart">
          <Modal.Header>
            <Modal.Title>
              <div className="cart-address">
                <div className="left-arrrow" onClick={MovetoCart}>
                  <HiOutlineArrowLeft />
                </div>
                <div className="left-address">
                  {JSON.parse(localStorage.getItem("site_data"))
                    .ecommerce_type !== "Conventional"
                    ? "My Address"
                    : "Enter Delivery Details"}
                </div>
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body
            className={
              isMobile
                ? "cart-modal-rn-address-mobile"
                : "cart-modal-rn-address"
            }
          >
            <div className="add-address-main">
              {JSON.parse(localStorage.getItem("site_data")).ecommerce_type !==
                "Conventional" ? (
                <div className="add-address-nav" onClick={HandleAddress}>
                  <div className="add-icon-nav">
                    <MdOutlineAddCircleOutline />
                  </div>
                  <div className="address-head-nav">Add a new address in</div>
                </div>
              ) : DefaultPincode ? (
                <div className="addressStripV2-base-desktopContainer ">
                  <div className="addressStripV2-base-title">
                    Deliver to:{localStorage.getItem("pincode")}
                  </div>
                  <button
                    className="btn btn-primary"
                    onClick={() => setDefaultPincode("")}
                  >
                    Change Address
                  </button>
                </div>
              ) : (
                <div className="inputV2-base-inputRow ">
                  <input
                    className=" inputV2-base-input "
                    id="pincode"
                    placeholder="Enter Pincode"
                    type="tel"
                    maxLength="6"
                    onChange={(e) => setPincode(e.target.value)}
                  />
                  <div
                    className={`CheckDeliveryModalV2-base-checkBtn ${pincode.length === 6
                      ? ""
                      : "CheckDeliveryModalV2-base-inValid"
                      }`}
                    onClick={localityFilter}
                  >
                    CHECK
                  </div>
                  {error && (
                    <div className="Loginerror">
                      Service not available for this selected pincode
                    </div>
                  )}
                </div>
              )}
              <div>
                {Address.length > 0 && (
                  <div className="address-p">
                    <div className="d-flex align-items-center justify-content-between">
                      <div>Choose Delivery Address</div>
                      {JSON.parse(localStorage.getItem("site_data"))
                        .ecommerce_type === "Conventional" && (
                          <div
                            className="address-head-nav"
                            onClick={HandleAddress}
                            style={{ color: "#3cac47", cursor: "pointer" }}
                          >
                            Add a new address in
                          </div>
                        )}
                    </div>
                  </div>
                )}
                {storeNull && orderAddress?.id && (
                  <div className="Loginerror">
                    Currently, service not available in the selected address
                  </div>
                )}
                {Error && (
                  <div className="Loginerror">
                    Service not available for this selected pincode
                  </div>
                )}
              </div>
              <div className="address-container">
                {Address.length > 0 ? (
                  Address.map((address, i) => (
                    <div
                      key={i}
                      className="address-main d-flex align-items-center"
                    >
                      <div
                        className="form-check"
                        onClick={async () => {
                          const siteData = JSON.parse(
                            localStorage.getItem("site_data")
                          );
                          try {
                            const userId = localStorage.getItem("userId");
                            await axiosConfig.post("accounts/default_address/", {
                              user: parseInt(userId),
                              address_id: address.id,
                            });
                            localStorage.setItem("address_id", address.id);
                            setOrderAddress(address);
                            if (siteData.ecommerce_type !== "Conventional") {
                              GetAddress(address.id);
                            } else {
                              localStorage.setItem("pincode", address?.pincode);
                            }
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                      >
                        <input
                          className="form-check-input"
                          type="radio"
                          name="exampleRadios"
                          checked={orderAddress?.id === address.id}
                          readOnly
                        />
                      </div>
                      <div>
                        <div className="address-ass">
                          {address.address_type}
                        </div>
                        <div className="address-detail">
                          {`${address.address ? `${address.address},` : ""} ${address.landmark ? `${address.landmark},` : ""
                            } ${address.pincode ? `${address.pincode}` : ""}`}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div>
                    <button
                      className="btn btn-primary btn-block"
                      onClick={HandleAddress}
                    >
                      Add New Address
                    </button>
                  </div>
                )}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-success btn-proceed"
              disabled={!orderAddress || Error}
              onClick={() => setCount(1)}
            >
              <p className="p-pay">Done</p>
            </button>
          </Modal.Footer>
        </Modal>
      )}
      {popupType !== "" && (
        <PopupModal
          popupType={popupType}
          setPopupType={setPopupType}
          error={Error}
          Message={message}
        />
      )}
    </div>
  );
};

export default ViewCartModal;
